import { cn } from "@heroui/react";
import React, { type JSX } from "react";

type TitleProps = {
  children: React.ReactNode;
  level: 1 | 2 | 3 | 4 | 5 | 6;
  size?:
    | "xxxs"
    | "xxs"
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl";
  weight?:
    | "thin"
    | "extralight"
    | "light"
    | "normal"
    | "medium"
    | "semibold"
    | "bold"
    | "extrabold"
    | "black";
  tracking?: "tight" | "normal" | "wide";
  textColor?: "content1" | "content2" | "content3" | "content4";
  className?: string;
  leading?: number;
  id?: string;
};

// Recommended sizes
const sizeMap = {
  xxxs: "text-xxxs",
  xxs: "text-xxs",
  xs: "text-xs",

  //Descriptions, subtitles
  sm: "text-sm",
  md: "text-md",

  // Items titles
  lg: "text-lg",
  xl: "text-xl",

  //Section titles
  "2xl": "text-2xl",
  "3xl": "text-3xl",

  //Page titles
  "4xl": "text-4xl",
  "5xl": "text-5xl",
};

const weightMap = {
  thin: "font-thin",
  extralight: "font-extralight",
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold",
  extrabold: "font-extrabold",
  black: "font-black",
};

const leadingMap = {
  3: "!leading-3",
  4: "!leading-4",
  5: "!leading-5",
  6: "!leading-6",
  7: "!leading-7",
  8: "!leading-8",
  9: "!leading-9",
  10: "!leading-10",
};

export default function Title({
  children,
  level,
  size = "md",
  weight = "normal",
  leading,
  className = "",
  id,
}: TitleProps) {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;

  const sizeClass = sizeMap[size];
  const weightClass = weightMap[weight];
  //   @ts-ignore
  const leadingClass = leading ? leadingMap[leading] : "";

  return (
    <Tag
      className={cn(sizeClass, weightClass, leadingClass, className)}
      id={id}
    >
      {children}
    </Tag>
  );
}
